import { graphql } from "@/gql";

export const relocationPageRecordQuery = graphql(`
  query RelocationPageRecord($id: ID!) {
    relocationPageById(id: $id) {
      id
      slug
      description
      title
      region
      created_at
      updated_at
      image {
        ...MediaFields
      }
      points {
        lat
        lng
        radius
        type
      }
      articles {
        id
        dato_article_slug
        sort_order
      }
    }
  }
`);
